export interface ICoordinatorListByCenter {
    centerId: number,
    list: any[]
}

